import { createFileRoute, Link } from "@tanstack/react-router";
import { listProgrammaticPages } from "@/lib/site-data";

export const Route = createFileRoute("/seo/")({
  head: () => ({
    meta: [
      { title: "Local Trade SEO Pages — Lehi Trades SEO" },
      {
        name: "description",
        content:
          "Hyper-local SEO landing pages for plumbers, electricians, HVAC, and roofers across every Utah County city we cover.",
      },
      { property: "og:title", content: "Local Trade SEO Pages — Lehi Trades SEO" },
      {
        property: "og:description",
        content:
          "Plumber, electrician, HVAC, and roofer SEO pages for every Utah County city.",
      },
      { property: "og:url", content: "https://lehitradessaeo.com/seo" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://lehitradessaeo.com/seo" }],
  }),
  component: SeoIndex,
});

function SeoIndex() {
  const pages = listProgrammaticPages();
  // Group by trade
  const grouped = pages.reduce<Record<string, typeof pages>>((acc, p) => {
    (acc[p.trade.slug] ||= []).push(p);
    return acc;
  }, {});

  return (
    <main className="mx-auto max-w-5xl px-6 py-20">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
          Local trade pages
        </p>
        <h1 className="mt-3 font-display text-4xl tracking-tight md:text-5xl">
          Trade + city SEO pages
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          Hyper-local landing pages built for one trade in one city — population,
          housing stock, weather, and emergency-call patterns included.
        </p>
      </header>

      <div className="mt-12 space-y-12">
        {Object.entries(grouped).map(([tradeSlug, items]) => {
          const tradeName = items[0].trade.trade;
          return (
            <section key={tradeSlug}>
              <h2 className="font-display text-2xl capitalize tracking-tight">
                {tradeName} SEO
              </h2>
              <ul className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {items.map(({ trade, city }) => (
                  <li key={`${trade.slug}-${city.slug}`}>
                    <Link
                      to="/seo/$trade/$city"
                      params={{ trade: trade.slug, city: city.slug }}
                      className="block rounded-xl border border-border bg-card p-4 transition hover:border-primary/40"
                    >
                      <div className="font-medium">
                        {trade.trade.replace(/^\w/, (c) => c.toUpperCase())} SEO in {city.name}, {city.region}
                      </div>
                      <div className="mt-1 text-xs text-muted-foreground">
                        {city.neighborhoods.slice(0, 2).join(" · ")}
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </main>
  );
}